import { useEffect, useState, useRef, useCallback } from 'react'
import { withUIContext, withUserContext, withDataContext } from 'context'

import { Tabs } from 'antd'
import { Empty, FilterSortBy, ButtonLoadMore } from 'components/common'
import { Debates } from 'components/pages'
import FilterBarStyle from './style'

const FilterBar = ({ homeDebates, getHomeDebates, ...props }) => {
    const [hasMore, setHasMore] = useState(false)
    const [activeTab, setActiveTab] = useState('feed')

    const loadMore = useRef()
    const tabChangeRef = useRef()

    useEffect(() => {
        getHomeDebates({
            isMyProfile: true,
            sortBy: 'DESC',
            offset: 0,
            userId: props?.user?.id || 0,
            type: 'feed'
        })
    }, [props.user])

    useEffect(() => {
        checkHasMore(activeTab)
    }, [homeDebates])

    const checkHasMore = (key) => {
        setActiveTab(key)
        setHasMore(homeDebates[key]?.length < homeDebates[`${key}Total`])
    }

    const tabChange = useCallback((activeTab) => {
        tabChangeRef.current(activeTab)
    }, [])

    const handleLoadMore = useCallback(() => {
        loadMore.current(homeDebates[activeTab]?.length, activeTab)
    }, [activeTab, homeDebates])

    return homeDebates ? (
        <FilterBarStyle className='filter-bar flexBoxColumn'>
            <Tabs activeKey={activeTab} onChange={checkHasMore} onTabClick={tabChange}>
                <Tabs.TabPane tab={'Feed'} key={'feed'}>
                    {homeDebates.feedTotal ? (
                        <Debates debates={homeDebates.feed} />
                    ) : (
                        <Empty className={'empty'} />
                    )}
                </Tabs.TabPane>
                {props.isLoggedIn && (
                    <>
                        <Tabs.TabPane tab={'Favorites'} key={'favorites'}>
                            {homeDebates.favoritesTotal > 0 ? (
                                <Debates debates={homeDebates.favorites} />
                            ) : (
                                <Empty className={'empty'} />
                            )}
                        </Tabs.TabPane>
                        <Tabs.TabPane tab={'My Debates'} key={'myDebates'}>
                            {homeDebates.myDebatesTotal > 0 ? (
                                <Debates debates={homeDebates.myDebates} />
                            ) : (
                                <Empty className={'empty'} />
                            )}
                        </Tabs.TabPane>
                        <Tabs.TabPane tab={'Participating'} key={'participating'}>
                            {homeDebates.participatingTotal > 0 ? (
                                <Debates debates={homeDebates.participating} />
                            ) : (
                                <Empty className={'empty'} />
                            )}
                        </Tabs.TabPane>
                    </>
                )}
            </Tabs>
            <FilterSortBy
                isMyProfile={true}
                activeKey={activeTab}
                handleFunc={'getHomeDebates'}
                loadMore={loadMore}
                tabChange={tabChangeRef}
            />
            {hasMore && (
                <ButtonLoadMore
                    onClick={handleLoadMore}
                    className='align-center load-more-btn'
                    text='Load more'
                />
            )}
        </FilterBarStyle>
    ) : null
}
export default withUIContext(withUserContext(withDataContext(FilterBar,
    ['getHomeDebates', 'homeDebates']),
    ['isLoggedIn', 'user']),
    ['winWidth'])
